// Shared cross-portal SSO cookie used by app.nurturingnurses.net,
// clinical.nurturingnurses.net, and other NNHC portals. Mirrors the
// pattern used in Command Center: JSON-encoded { access_token,
// refresh_token, expires_at } stored under nnhc_session on the parent
// domain so any subdomain can hydrate a Supabase session.

const COOKIE_NAME = 'nnhc_session';
const COOKIE_DOMAIN = '.nurturingnurses.net';
const DEFAULT_MAX_AGE = 60 * 60 * 8; // 8 hours

function isSecureContext() {
  if (typeof window === 'undefined') return true;
  return window.location.protocol === 'https:';
}

export function setSharedSessionCookie(session) {
  if (typeof document === 'undefined' || !session) return;
  const { access_token, refresh_token, expires_at } = session;
  if (!access_token || !refresh_token) return;

  const payload = JSON.stringify({ access_token, refresh_token, expires_at });
  const maxAge = expires_at
    ? Math.max(60, Math.floor(expires_at - Date.now() / 1000))
    : DEFAULT_MAX_AGE;

  const parts = [
    `${COOKIE_NAME}=${encodeURIComponent(payload)}`,
    'Path=/',
    `Max-Age=${maxAge}`,
    'SameSite=Lax',
  ];
  if (isSecureContext()) parts.push('Secure');
  if (
    typeof window !== 'undefined' &&
    window.location.hostname.endsWith('nurturingnurses.net')
  ) {
    parts.push(`Domain=${COOKIE_DOMAIN}`);
  }

  document.cookie = parts.join('; ');
}

export function clearSharedSessionCookie() {
  if (typeof document === 'undefined') return;
  const parts = [
    `${COOKIE_NAME}=`,
    'Path=/',
    'Max-Age=0',
    'SameSite=Lax',
  ];
  if (isSecureContext()) parts.push('Secure');
  if (
    typeof window !== 'undefined' &&
    window.location.hostname.endsWith('nurturingnurses.net')
  ) {
    parts.push(`Domain=${COOKIE_DOMAIN}`);
  }
  document.cookie = parts.join('; ');
}
